module.exports = __webpack_public_path__ + "static/media/Budew_gaussian2.94d98bfb.png";